import React from 'react'
import {usePreventiveTranslations} from '@common/utils'

import {
  ActivityRow,
  ActivityStatus as StyledStatus,
  ActivityText,
} from '../styles/styled'

import {PreventiveActivity} from '~/types/preventive'
import {Container} from '~/components/general/container/Container'
import {getActivityBackgroundColor} from '~/utils/preventive'

type ActivityStatusProps = {
  activity: PreventiveActivity
}

export const ActivityStatus: React.FC<ActivityStatusProps> = ({activity}) => {
  const {getTranslatedDescription} = usePreventiveTranslations()

  return (
    <Container>
      <ActivityRow>
        <StyledStatus backgroundColor={getActivityBackgroundColor(activity)} />
        <ActivityText>
          {getTranslatedDescription(activity.description)}
        </ActivityText>
      </ActivityRow>
    </Container>
  )
}
